import { MENU } from "./reducer";
import { MENU_ID } from "./initialState";

export const getSelectedMenuItem = state => state.getIn([MENU, MENU_ID]);

export default {};